// Whether the event passed through an element matching the selector. Unlike walking up from
// event.target, this still works when an earlier listener unmounted the target — a dropdown
// row that closes its list on mousedown, say. The path is fixed when the event is dispatched,
// so it names the ancestors the target had at that moment. Document and window sit on the
// path too and have no matches(), hence the duck check rather than instanceof.
export function eventPathMatches(event: Event, selector: string): boolean {
  return event.composedPath().some((node) => typeof (node as Element).matches === 'function' && (node as Element).matches(selector));
}
